import { Text, View, Image } from '@react-pdf/renderer';
import { S3_URL } from 'constants';
import { IMAGE_PATHS } from 'constants/imagePaths';
import parse from 'html-react-parser';
import { convertToPng } from 'utils';

const About = ({ styles, data: { shortBio = '', profilePicture }, headerTitle }: any) => {
	return (
		<View style={styles.about}>
			{profilePicture && (
				<View style={styles.profileBox}>
					<Image style={styles.profileBG} src={IMAGE_PATHS.profileFrame} />
					{profilePicture && (
						<Image style={styles.userImg} src={convertToPng(S3_URL + profilePicture)} />
					)}
				</View>
			)}

			{shortBio && (
				<View style={styles.profileContent}>
					<View style={styles.headingBox}>
						<Text style={styles.heading}>{headerTitle}</Text>
					</View>

					<Text style={styles.detailSubText}>{parse(shortBio)}</Text>
				</View>
			)}
		</View>
	);
};

export default About;
